import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('medbuddy_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const authAPI = {
  register: async (name, email, password) => {
    const response = await axios.post(`${API}/auth/register`, { name, email, password });
    return response.data;
  },
  login: async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    return response.data;
  },
};

export const medicationsAPI = {
  create: async (medicationData) => {
    const response = await axios.post(`${API}/medications`, medicationData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getAll: async () => {
    const response = await axios.get(`${API}/medications`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getDue: async () => {
    const response = await axios.get(`${API}/medications/due`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getToday: async () => {
    const response = await axios.get(`${API}/medications/today`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getCurrentSlot: async () => {
    const response = await axios.get(`${API}/medications/current-slot`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  update: async (medicationId, updateData) => {
    const response = await axios.patch(`${API}/medications/${medicationId}`, updateData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};

export const doseLogsAPI = {
  create: async (logData) => {
    const response = await axios.post(`${API}/dose-logs`, logData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getHistory: async () => {
    const response = await axios.get(`${API}/dose-logs/history`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  getProgress: async () => {
    const response = await axios.get(`${API}/dose-logs/progress`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};

export const settingsAPI = {
  get: async () => {
    const response = await axios.get(`${API}/settings`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  update: async (settingsData) => {
    const response = await axios.put(`${API}/settings`, settingsData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};

export default {
  authAPI,
  medicationsAPI,
  doseLogsAPI,
  settingsAPI,
};